import { typeUtils } from '@festina-life/core'
import type { FormikProps } from '@festina-life/ui/formikForms'

import type { BranchCreationInput } from '../types'

export const validate = typeUtils.createValidator<BranchCreationInput>()

export const resetFields = (
  { setFieldValue, initialValues }: FormikProps<BranchCreationInput>,
  fieldNames: (keyof BranchCreationInput)[],
) =>
  Promise.all(
    fieldNames.map((fieldName) =>
      setFieldValue(validate(fieldName), initialValues[fieldName]),
    ),
  )
